import styled from "styled-components";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import { useEffect, useState } from "react";
import { useModal } from "../../contexts/ModalContext";
import ModalNewEmail from "./ModalNewEmail";

import useApi from "../../hooks/useApi";
const ContainerTabela = styled.div`
    width: 100%;
    max-height: 500px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
`

const TabelaValores = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-top: 1rem;
    color: black;
    position: relative;

    thead{
        position: sticky;
        top: 0;
        z-index: 2;
    }

    th, td{
        border: 1px solid #ddd;
        padding: 8px;
        text-align: center;
    }

    th {
        background: #f4f4f4;
        font-weight: bold;
    }

    tr:nth-child(even) {
        background: #fafafa;
    }

    input {
        width: 80px;
        text-align: right;
        padding: 4px;
        border: 1px solid #ccc;
        border-radius: 4px;
    }

    input:focus {
        outline: none;
        border-color: #0077ff;
        box-shadow: 0 0 4px rgba(0,119,255,0.4);
    }
`

const SaveButtonContainer = styled.div`
    width: 100%;
    height: 40px;
    display: flex;
`

const SaveButton = styled.button`
    width: 180px;
    height: 100%;
    border: none;
    background-color: green;
    border-radius: 8px;
    cursor: pointer;
    margin: 10px 0 0 0;
    color: white;
    font-weight: bold;
    transition: .3s;
    &:hover{
        scale: 1.05;
    }
`

const ContainerTabelaEmails = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
`

const TabelaEmails = styled.table`
    width: 100%;
    border-collapse: collapse;
    color: black;

    th, td{
        border: 1px solid #ddd;
        padding: 8px;
        text-align: center;
    }

    th {
        background: #f4f4f4;
        font-weight: bold;
    }

    tr:nth-child(even) {
        background: #fafafa;
    }

    tr:nth-child(odd) {
        background: #fff;
    }
`
const LinhaNovoEmail = styled.td`
    background-color: #00c400 !important;
    color: white;
    cursor: pointer;
    transition: .3s;

    &:hover{
        background-color: #00db00 !important;
    }
`

const ModalValoresExames = ({ clinica, fecharModal }) => {
    const api = useApi();


    const { openModal, closeModal, isModalOpen } = useModal();

    const [valores, setValores] = useState([])
    const [emailsClinica, setEmailsClinica] = useState([])
    const [emailsPalmont, setEmailsPalmont] = useState([])

    const fetchValores = async () => {
        try {

            const [ valoresRes, emailsRes ] = await Promise.all([
                api.get(`/Painel/API/ASO/GetExamesValores/index.php?clinica=${clinica}`),
                api.get(`/Painel/API/ASO/GetClinicaEmails/index.php?clinica=${clinica}`)
            ])

            const valoresData = valoresRes.data
            const emailsData = emailsRes.data

            console.log( emailsData )

            const emailsClinica = emailsData
                .filter(e => e.referencia === "CLÍNICA")
                .map(e => ({
                    id: e.id,
                    clinica: e.clinica,
                    email: e.email
                }))
      
            const emailsPalmont = emailsData
                .filter(e => e.referencia === "PALMONT")
                .map(e => ({
                    id: e.id,
                    clinica: e.clinica,
                    email: e.email
                }))

            setEmailsClinica( emailsClinica );
            setEmailsPalmont( emailsPalmont );
            setValores( valoresData );

        } catch (e) {

            console.log(e)

        }

    }

    useEffect(() => {

        fetchValores();

    }, [])

    useEffect(() => {

        console.log( emailsClinica )

    }, [emailsClinica])

    const handleChange = (index, field, value) => {
        const novosValores = [...valores];
        novosValores[index][field] = value;
        setValores(novosValores);
    };

    const handleSave = async () => {

        try{

            const payload = { clinica, valores }

            const { data } = await api.post('/Painel/API/ASO/EditValoresExames/', payload, {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                }
            })

            console.log( data )

        }catch(e){

            console.log( e )

        }

    }

    const [ referenciaEmail, setReferenciaEmail ] = useState( null );
    const [ emailItem, setEmailItem ] = useState( null );

    const openNewEmail = ( referencia, item = null ) => {

        setEmailItem( item )
        setReferenciaEmail( referencia )
        openModal('addEmailClinica')

    }

    const closeNewEmail = () => {

        setEmailItem( null )
        setReferenciaEmail( null );
        closeModal();

    }

    return (
        <>
            <Overlay state={true} >
                <Modal size="lg" header={true} close={fecharModal} >
                    <ContainerTabelaEmails>
                        <TabelaEmails>
                            <thead>
                                <tr>
                                    <th>LISTA DE E-MAILS CLÍNICA</th>
                                </tr>
                            </thead>
                            <tbody>
                                {emailsClinica.map(( obj ) => (
                                    <tr key={ obj.id } >
                                        <td onClick={() => openNewEmail( 'CLÍNICA', obj )} >{ obj.email }</td>
                                    </tr>
                                ))}
                                <tr>
                                    <LinhaNovoEmail onClick={() => openNewEmail( 'CLÍNICA' )} >
                                        NOVO E-MAIL
                                    </LinhaNovoEmail>
                                </tr>
                            </tbody>
                        </TabelaEmails>
                    </ContainerTabelaEmails>
                    <ContainerTabelaEmails>
                        <TabelaEmails>
                            <thead>
                                <tr>
                                    <th>LISTA DE E-MAILS PALMONT</th>
                                </tr>
                            </thead>
                            <tbody>
                                {emailsPalmont.map(( obj ) => (
                                    <tr key={ obj.id } >
                                        <td onClick={() => openNewEmail( 'PALMONT', obj )} >{ obj.email }</td>
                                    </tr>
                                ))}
                                <tr>
                                    <LinhaNovoEmail onClick={() => openNewEmail( 'PALMONT' )} >
                                        NOVO E-MAIL
                                    </LinhaNovoEmail>
                                </tr>
                            </tbody>
                        </TabelaEmails>
                    </ContainerTabelaEmails>
                    <ContainerTabela>
                        <TabelaValores>
                            <thead>
                                <tr>
                                    <th>EXAME</th>
                                    <th>ADMISSIONAL</th>
                                    <th>PERIÓDICO</th>
                                    <th>RETORNO AO TRABALHO</th>
                                    <th>MUDANÇA DE RISCO</th>
                                    <th>DEMISSIONAL</th>
                                </tr>
                            </thead>
                            <tbody>
                                {valores.map((item, idx) => (
                                    <tr key={idx} >
                                        <td>{item.exame}</td>
                                        <td><input type="number" value={item.tipo_0} onChange={e => handleChange(idx, "tipo_0", e.target.value)} /></td>
                                        <td><input type="number" value={item.tipo_1} onChange={e => handleChange(idx, "tipo_1", e.target.value)} /></td>
                                        <td><input type="number" value={item.tipo_2} onChange={e => handleChange(idx, "tipo_2", e.target.value)} /></td>
                                        <td><input type="number" value={item.tipo_3} onChange={e => handleChange(idx, "tipo_3", e.target.value)} /></td>
                                        <td><input type="number" value={item.tipo_9} onChange={e => handleChange(idx, "tipo_9", e.target.value)} /></td>
                                    </tr>
                                ))}
                            </tbody>
                        </TabelaValores>
                    </ContainerTabela>
                    <SaveButtonContainer>
                        <SaveButton
                            onClick={ handleSave }
                        >
                            SALVAR ALTERAÇÕES
                        </SaveButton>
                    </SaveButtonContainer>
                </Modal>
            </Overlay>
            {
                isModalOpen('addEmailClinica') && (
                    <ModalNewEmail
                        clinica={ clinica }
                        referencia={ referenciaEmail }
                        fecharModal={ closeNewEmail }
                        fetchSuccess={ fetchValores }
                        item={ emailItem }
                    />
                )
            }
        </>
    )
}

export default ModalValoresExames;